import { Subject } from 'rxjs';
import { DEFAULT_PAGE_SIZE, Grid_ORDER } from '../../../widgets/grid/grid.model';

export enum GridLogActionType {
    reloadGrid,
}

export enum GridLogEventType {
    totalUpdate,
    sortParamsToGet
}

export class GridLogConfig {
    actions$: Subject<{ type: GridLogActionType, payload?: FilterParams }>;
    // totalUpdate payload type nimber, sortParamsToGet payload type GridPayload
    events$: Subject<{ type: GridLogEventType, payload?: any }>;
    constructor() {
        this.actions$ = new Subject();
        this.events$ = new Subject();
    }
}

export class FilterParams {
    filters: Filters;
}

export class Filters {
    logicalOperator: string;
    filters: Array<Filter>;
}

export class Filter {
    field: string;
    value: string;
    operator: string;
}

export class GridPageParams {
    rpp: number;
    page: number;
    sortby: string;
    sortorder: string;
    filter?: FilterParams;
    constructor() {
        this.rpp = DEFAULT_PAGE_SIZE;
        this.page = 1;
        this.sortby = 'operate_time';
        this.sortorder = Grid_ORDER.DESC;
    }
}
